import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allProducts } from 'app/mocks/data/catalogue/products'
import { allSites } from 'app/mocks/data/park/sites'

import { api } from 'app/utils/constants'

import { Order, PayloadOrder } from 'app/types/operations/order'

export const createOrder = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.operations.orders.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = PayloadOrder.safeParse(payload)

        // Wrong payload
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<Order>(
            {
                id: 999,
                ...payloadParsed.data,
                site: allSites.find(
                    (site) => site.id === payloadParsed.data.site,
                ),
                articles: payloadParsed.data.articles.map((article) => ({
                    ...article,
                    product: allProducts.find(
                        (product) => product.id === article.product,
                    ),
                })),
            },
            {
                status: StatusCodes.CREATED,
            },
        )
    },
)
